var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckmarkBold = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.899.799a1.5 1.5 0 0 1 .302 2.1L7.625 13.025a1.5 1.5 0 0 1-2.262.162L.94 8.763a1.5 1.5 0 1 1 2.122-2.12l3.2 3.198 6.538-8.74a1.5 1.5 0 0 1 2.1-.302Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckmarkBold);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checkmark-bold.5adbc3d147b11dc2d8f1ed294318b263.svg";